// Persistent anonymous ID stored in localStorage – used for like de-duplication
// (one like per browser per news item, no registration needed).
const KEY = "aluzyjna_anon_id";

function uuid() {
    if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

export function getAnonId() {
    if (typeof window === "undefined") return "";
    let v = window.localStorage.getItem(KEY);
    if (!v) {
        v = uuid();
        try { window.localStorage.setItem(KEY, v); } catch { /* ignore quota */ }
    }
    return v;
}
